import {useState} from "react";
import {Stack, Typography, Divider} from "@mui/material";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";

export default function EnvironmentalImpactDisplay(props) {
  const {mappings, defaultLanguage, objList, topLabel} = props;
  // console.log(objList);
  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }
  if (!objList || objList.length === 0 || objList.every((item) => item.isEmpty?.() ?? true)) return null;

  return (
    <>
      <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>{topLabel}</Typography>
      <Stack sx={{pt: 1, pb: 2}} spacing={1}>
        {objList.map((item, index) => {
          const isLastElement = index === objList.length - 1;
          return (
            <div key={index}>
              {item.measurementMethodology && !isEmpty(item.measurementMethodology.getValue(defaultLanguage)) && (
                <div>
                  <Typography variant="body2" className="key">
                    {getLabel(keys.measurementMethodology, "measurementMethodology")}
                  </Typography>
                  <Typography variant="body1">
                    {item.measurementMethodology.getValue(defaultLanguage)}
                  </Typography>
                </div>
              )}

              {item.powerConsumption && !isEmpty(item.powerConsumption.getValue(defaultLanguage)) && (
                <div>
                  <Typography variant="body2" className="key">
                    {getLabel(keys.powerConsumption, "powerConsumption")}
                  </Typography>
                  <Typography variant="body1">
                    {item.powerConsumption.getValue(defaultLanguage)}
                  </Typography>
                </div>
              )}
              <Divider component="div" role="presentation" className={`dashed ${ isLastElement ? "hide-divider" : ""}`}/>
            </div>
          );
        })}
      </Stack>
    </>
  );
}
